<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de leilão</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- ATIVAR REGRESSIVA -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_acionar_regressiva_apos">Ativar regressiva faltando (s)</label>
                <input
                  class="form-control"
                  id="leilao_acionar_regressiva_apos"
                  v-model="formData.leilao_acionar_regressiva_apos"
                />

                <span style="color: red" v-for="error in v$.leilao_acionar_regressiva_apos.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- REINICIAR TEMPO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_regressiva">Reiniciar o tempo em (s)</label>
                <input class="form-control" id="leilao_regressiva" v-model="formData.leilao_regressiva" />

                <span style="color: red" v-for="error in v$.leilao_regressiva.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INTERVALO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_lote_intervalo">Intervalo entre os lotes (s)</label>
                <input class="form-control" id="leilao_lote_intervalo" v-model="formData.leilao_lote_intervalo" />

                <span style="color: red" v-for="error in v$.leilao_lote_intervalo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- TEMPO PRIMEIRO LOTE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_primeiro_lote_margem_tempo">Primeiro lote inicia com (s)</label>
                <input
                  class="form-control"
                  id="leilao_primeiro_lote_margem_tempo"
                  v-model="formData.leilao_primeiro_lote_margem_tempo"
                />

                <span style="color: red" v-for="error in v$.leilao_primeiro_lote_margem_tempo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILOEIRO RESPONSÁVEL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leiloeiro_responsavel">Leiloeiro responsável</label>

                <select class="custom-select rounded-0" id="leiloeiro_responsavel" v-model="formData.leiloeiro_id">
                  <option v-for="leiloeiro in leiloeiros" :key="leiloeiro.id" :value="leiloeiro.id">
                    {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.leiloeiro_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- TAXA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_taxa_administrativa">Taxa administrativa</label>
                <input
                  class="form-control"
                  id="leilao_taxa_administrativa"
                  v-model="formData.leilao_taxa_administrativa"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option v-for="estado in estados" :key="estado" :value="estado">
                    {{ estado.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.estado.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select
                  @change="changeCidade"
                  class="custom-select rounded-0"
                  id="endereco_cidade"
                  v-model="formData.cidade"
                  style="text-transform: uppercase"
                >
                  <option v-for="cidade in cidades" :key="cidade" :value="cidade">
                    {{ cidade.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.cidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- COMITENTES -->
            <div class="col-sm-6">
              <div class="form-group" id="form_group_comitente">
                <label for="comitente">Comitente</label>

                <div class="input-group">
                  <v-autocomplete
                    id="comitente"
                    variant="outlined"
                    :items="my_comitentes"
                    item-title="nome"
                    return-object
                    v-model="formData.comitente"
                    density="compact"
                    style="text-transform: uppercase"
                  ></v-autocomplete>

                  <div class="input-group-append">
                    <button
                      style="max-height: 40px"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#comitente-modal"
                      @click="cadastrarComitente"
                    >
                      <i class="fas fa-plus"></i>
                      Adicionar
                    </button>
                  </div>
                </div>

                <span style="color: red" v-for="error in v$.comitente.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <div>
              <admin-cadastrar-comitente
                v-if="cadastrar_comitente"
                :estados="estados"
                :estado_selecionado="formData.estado_id"
                :cidade_selecionada="formData.cidade_id"
                :cidades_buscadas="cidades"
                :modal="true"
                :action="buscarComitenteCadastrado"
              />
            </div>

            <!-- MODO GENÉRICO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_modo_generico">Modo genérico</label>

                <select
                  class="custom-select rounded-0"
                  id="leilao_modo_generico"
                  v-model="formData.leilao_modo_generico"
                  style="text-transform: uppercase"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_modo_generico.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- TIPO LEILAO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_tipo">
                  Tipo (modalidade)
                  <button
                    @click="showModalidadeInfo()"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 60%; margin-left: 5px; font-size: 12px; font-weight: bold; padding-top: 1px; padding-bottom: 1px"
                  >
                    ?
                  </button>
                </label>

                <select
                  class="custom-select rounded-0"
                  id="leilao_tipo"
                  v-model="formData.leilao_tipo"
                  @change="alterarTipoLeilao()"
                  style="text-transform: uppercase"
                >
                  <option value="extra">Extra</option>
                  <option value="judicial">Judicial</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_tipo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- PROCESSO -->
            <div class="col-sm-6">
              <div class="form-group" id="form_group_processo">
                <label for="processo">Processo</label>

                <div class="input-group">
                  <v-autocomplete
                    id="processo"
                    variant="outlined"
                    :items="my_processos"
                    item-title="processo_numero"
                    return-object
                    v-model="formData.processo"
                    density="compact"
                  ></v-autocomplete>

                  <div class="input-group-append">
                    <button
                      :disabled="formData.leilao_tipo == 'extra'"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#processo-modal"
                      style="max-height: 40px"
                      @click="cadastrarProcesso"
                    >
                      <i class="fas fa-plus"></i>
                      Adicionar
                    </button>
                  </div>
                </div>

                <span v-if="formData.leilao_tipo == 'judicial'" style="color: red" v-for="error in v$.processo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <div>
              <admin-cadastrar-processo
                v-if="cadastrar_processo"
                :leiloeiros="leiloeiros"
                :estado_selecionado="formData.estado_id"
                :cidade_selecionada="formData.cidade_id"
                :cidades_buscadas="cidades"
                :estados="estados"
                :modal="true"
                :action="buscarProcessoCadastrado"
              />
            </div>

            <!-- TITULO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_titulo">Título</label>
                <input
                  class="form-control"
                  id="leilao_titulo"
                  v-model="formData.leilao_titulo"
                  @blur="upper('leilao_titulo')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.leilao_titulo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DESCRIÇÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_descricao">Descrição</label>
                <input
                  class="form-control"
                  id="leilao_descricao"
                  v-model="formData.leilao_descricao"
                  @blur="upper('leilao_descricao')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.leilao_descricao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LOCAL DO LEILÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_local">Local do leilão</label>
                <input class="form-control" id="leilao_local" v-model="formData.leilao_local" />

                <span style="color: red" v-for="error in v$.leilao_local.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LOGO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="logo">Logo</label>

                <select class="custom-select rounded-0" id="logo" v-model="formData.logo" style="text-transform: uppercase">
                  <option v-for="logo in logos" :key="logo" :value="logo">
                    {{ logo.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.logo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NÚMERO DE PRAÇAS -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_num_pracas">Número de praças</label>

                <select class="custom-select rounded-0" id="leilao_num_pracas" v-model="formData.leilao_num_pracas" @change="changePracas()">
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_num_pracas.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_1_data">1º Leilão</label>
                <div class="input-group">
                  <InputMask
                    id="leilao_data_1"
                    class="form-control"
                    v-model="formData.leilao_1_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <div id="leilao_1_data_error">
                  <span style="color: red" v-for="error in v$.leilao_1_data.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>
            </div>

            <!-- LEILÃO 01
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="leilao_1_data">1º Leilão</label>
                                <div class="input-group date" id="reservationdatetime" data-target-input="nearest">
                                    <input type="text" class="form-control datetimepicker-input"
                                        data-target="#reservationdatetime" id="data_leilao_1"
                                        data-date-format="DD/MM/YYYY HH:mm:ss" />
                                    <div class="input-group-append" data-target="#reservationdatetime"
                                        data-toggle="datetimepicker">
                                        <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                                    </div>
                                </div>

                                <span style="color: red" v-for="error in v$.leilao_1_data.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>
                        </div>
 -->
            <!-- MODALIDADE LEILÃO 01 -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_1_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_1_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_1_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 02 -->
            <div class="col-sm-6" v-show="formData.leilao_num_pracas >= 2">
              <div class="form-group">
                <label for="leilao_2_data">2º Leilão</label>
                <div class="input-group date" id="reservationdatetime2" data-target-input="nearest">
                  <InputMask
                    id="leilao_data_2"
                    class="form-control"
                    v-model="formData.leilao_2_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span v-if="formData.leilao_num_pracas >= 2" style="color: red" v-for="error in v$.leilao_2_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 02 -->
            <div class="col-sm-6" v-if="formData.leilao_num_pracas >= 2">
              <div class="form-group">
                <label for="leilao_2_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_2_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_2_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 03 -->
            <div class="col-sm-6" v-show="formData.leilao_num_pracas >= 3">
              <div class="form-group">
                <label>3º Leilão</label>
                <div class="input-group date" id="reservationdatetime3" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_3_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span v-if="formData.leilao_num_pracas >= 3" style="color: red" v-for="error in v$.leilao_3_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 03 -->
            <div class="col-sm-6" v-if="formData.leilao_num_pracas >= 3">
              <div class="form-group">
                <label for="leilao_3_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_3_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_3_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 04 -->
            <div class="col-sm-6" v-show="formData.leilao_num_pracas >= 4">
              <div class="form-group">
                <label for="leilao_4_data">4º Leilão</label>
                <div class="input-group date" id="reservationdatetime4" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_4_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span v-if="formData.leilao_num_pracas >= 4" style="color: red" v-for="error in v$.leilao_4_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 04 -->
            <div class="col-sm-6" v-if="formData.leilao_num_pracas >= 4">
              <div class="form-group">
                <label for="leilao_4_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_4_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_4_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INFORMAÇÕES GERAIS -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_info_geral">Informações gerais</label>

                <Editor style="background-color: white" v-model="formData.leilao_info_geral" editorStyle="height: 200px" />
              </div>
            </div>

            <!-- DATA LIBERAR LANCE -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_data_disponibilizar">Liberar os lances a partir de</label>
                <div class="input-group date" id="data_disponibilizar" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_data_disponibilizar"
                    placeholder="__/__/____  00:00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00:00"
                  />
                </div>

                <span style="color: red" v-for="error in v$.leilao_data_disponibilizar.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- BLOQUEAR HABILITAÇÕES -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_tempo_limite_habilitacao">Bloquear habilitações faltando (min)</label>
                <input type="number" class="form-control" id="leilao_tempo_limite_habilitacao" v-model="formData.leilao_tempo_limite_habilitacao" />

                <span style="color: red" v-for="error in v$.leilao_tempo_limite_habilitacao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXIBIR HABILITADOS 
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label for="leilao_exibir_habilitados">Exibir número de habilitados do leilão</label>

                                <select class="custom-select rounded-0" id="leilao_exibir_habilitados"
                                    v-model="formData.leilao_exibir_habilitados">
                                    <option :value="0">Não</option>
                                    <option :value="1">Sim</option>
                                </select>

                                <span style="color: red" v-for="error in v$.leilao_exibir_habilitados.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>
                        </div>
                        -->

            <!-- LEILÃO DE TESTE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="is_teste">Leilão de teste</label>

                <select class="custom-select rounded-0" id="is_teste" v-model="formData.is_teste" style="text-transform: uppercase">
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.is_teste.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button id="cadastrar" type="submit" class="btn btn-primary" @click="validate()">Cadastrar</button>
          <a type="submit" href="/admin/leiloes" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
import Editor from "primevue/editor";
import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import InputMask from "primevue/inputmask";
import moment from "moment";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados", "leiloeiros", "logos"],

  components: { Loading, Editor, InputMask },

  data() {
    return {
      nome: "",
      isLoading: false,
      cidades: [],
      my_comitentes: [],
      my_processos: [],
      cadastrar_processo: false,
      cadastrar_comitente: false,
      comitentes: [],
      comitentes_filtrados: [],
      selectedCountry: "",
    };
  },

  setup() {
    const formData = reactive({
      leilao_acionar_regressiva_apos: "180",
      leilao_regressiva: "180",
      leilao_lote_intervalo: "60",
      leilao_primeiro_lote_margem_tempo: "180",
      leiloeiro_id: "",
      leilao_taxa_administrativa: "",
      cidade: "",
      estado: "",
      comitente: "",
      leilao_modo_generico: 0,
      leilao_titulo: "LEILÃO JUDICIAL EM ",
      leilao_descricao: "",
      leilao_local: "EXCLUSIVAMENTE ONLINE",
      logo: "",
      leilao_tipo: "judicial",
      leilao_num_pracas: 2,
      leilao_1_modalidade: "virtual",
      leilao_2_modalidade: "virtual",
      leilao_3_modalidade: "virtual",
      leilao_4_modalidade: "virtual",
      leilao_1_data: "",
      leilao_2_data: "",
      leilao_3_data: "",
      leilao_4_data: "",
      leilao_data_disponibilizar: "",
      leilao_tempo_limite_habilitacao: 0,
      leilao_exibir_habilitados: 0,
      is_teste: 0,
      leilao_info_geral: "",
      processo: "",
      data_hora_inicial: "",
      estado_id: "",
      cidade_id: "",
    });

    const rules = computed(() => {
      let local_rules = {
        leilao_acionar_regressiva_apos: { required },
        leilao_regressiva: { required },
        leilao_lote_intervalo: { required },
        leilao_primeiro_lote_margem_tempo: { required },
        leiloeiro_id: { required },
        cidade: { required },
        estado: { required },
        comitente: { required },
        leilao_modo_generico: { required },
        leilao_titulo: { required },
        leilao_descricao: { required },
        leilao_local: { required },
        logo: { required },
        leilao_tipo: { required },
        leilao_num_pracas: { required },
        leilao_1_data: {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
        },
        leilao_1_modalidade: { required },
        leilao_data_disponibilizar: {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
        },
        leilao_tempo_limite_habilitacao: { required },
        leilao_exibir_habilitados: { required },
        is_teste: { required },
      };

      if (formData.leilao_tipo == "judicial") {
        local_rules.processo = {
          required,
        };
      }

      if (formData.leilao_num_pracas >= 2) {
        local_rules.leilao_2_data = {
          required,
          minDatePraca2: helpers.withMessage(" Esta praça deve ser após a 1º praça.", minDatePraca2),
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
        };
        local_rules.leilao_2_modalidade = {
          required,
        };
      }

      if (formData.leilao_num_pracas >= 3) {
        local_rules.leilao_3_data = {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
          minDatePraca3: helpers.withMessage(" Esta praça deve ser após a 2º praça.", minDatePraca3),
        };
        local_rules.leilao_3_modalidade = {
          required,
        };
      }

      if (formData.leilao_num_pracas >= 4) {
        local_rules.leilao_4_data = {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
          minDatePraca4: helpers.withMessage(" Esta praça deve ser após a 3º praça.", minDatePraca4),
        };
        local_rules.leilao_4_modalidade = {
          required,
        };
      }

      return local_rules;
    });

    const validDate = (value) => {
      return moment(value, "DD/MM/yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss") != "Invalid date";
    };

    const minDatePraca4 = (date) => {
      if (!formData.leilao_2_data || !date) {
        return true;
      } else {
        let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
        let data2 = new Date(moment(formData.leilao_3_data, "DD-MM-yyyy HH:mm"));
        return data > data2;
      }
    };

    const minDatePraca3 = (date) => {
      if (!formData.leilao_2_data || !date) {
        return true;
      } else {
        let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
        let data2 = new Date(moment(formData.leilao_2_data, "DD-MM-yyyy HH:mm"));
        return data > data2;
      }
    };

    const minDatePraca2 = (date) => {
      if (!formData.leilao_2_data || !date) {
        return true;
      } else {
        let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
        let data2 = new Date(moment(formData.leilao_1_data, "DD-MM-yyyy HH:mm"));
        return data > data2;
      }
    };

    const minDate = (date) => {
      let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
      return data >= new Date();
    };

    const minDateLances = (date) => {
      let data = new Date(moment(date, "DD-MM-yyyy HH:mm:ss"));
      return data >= new Date() || data >= new Date(moment(formData.data_hora_inicial, "DD-MM-yyyy HH:mm:ss"));
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.formData.leiloeiro_id = this.leiloeiros[0].id;
    this.my_comitentes = this.comitentes;

    //this.buscarComitentes();
    //this.buscarprocessos();

    this.formData.data_hora_inicial = moment(new Date()).format("DD-MM-yyyy HH:mm:ss");
    this.formData.leilao_data_disponibilizar = moment(new Date()).format("DD-MM-yyyy HH:mm:ss");
  },

  methods: {
    buscarprocessos() {
      let data = {
        inicio: 0,
        tamanho: 100000,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          this.processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    showModalidadeInfo() {
      this.$swal
        .fire({
          icon: "info",
          title: "Tipo (modalidade)",
          padding: "1.5em",
          text: 'Esse campo aparece na tela do usuário como "Modalidade".',
        })
        .then(function () {});
    },

    search(input) {
      if (input.length < 1) {
        return [];
      }
      return this.my_comitentes.filter((comitente) => {
        return comitente.nome.toLowerCase().startsWith(input.toLowerCase());
      });
    },

    cadastrarComitente() {
      if (this.formData.cidade && this.formData.cidade.id) {
        this.cadastrar_comitente = true;
      } else {
        this.cadastrar_comitente = false;
        this.showErrorMessageWithButton("Ops...", "Selecione uma cidade.");
      }
    },

    cadastrarProcesso() {
      if (this.formData.cidade && this.formData.cidade.id) {
        this.cadastrar_processo = true;
      } else {
        this.cadastrar_processo = false;
        this.showErrorMessageWithButton("Ops...", "Selecione uma cidade.");
      }
    },

    searchComitentesArray(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.comitentes_filtrados = [...this.comitentes];
        } else {
          this.comitentes_filtrados = this.comitentes.filter((country) => {
            return country.nome.toLowerCase().startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },

    buscarprocessos() {
      let data = {
        inicio: 0,
        tamanho: 10000,
      };

      if (this.formData.cidade) {
        data.cidade_id = this.formData.cidade.id;
      }

      if (this.formData.estado) {
        data.estado_id = this.formData.estado.id;
      }

      console.log("Buscando processos");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          console.log("Processos");
          console.log(response.data.processos);
          this.my_processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarComitentes(atribuir_comitente) {
      let data = {
        inicio: 0,
        tamanho: 10000,
        alfabetico: true,
      };

      if (this.formData.cidade) {
        data.cidade = this.formData.cidade.id;
      }

      if (this.formData.estado) {
        data.estado = this.formData.estado.id;
      }

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
          this.my_comitentes = response.data.comitentes;

          for (let i = 0; i < this.my_comitentes.length; i++) {
            if (this.my_comitentes[i].nome) {
              this.my_comitentes[i].nome = this.my_comitentes[i].nome.toUpperCase();
            }
          }

          if (atribuir_comitente) {
            this.formData.comitente = this.my_comitentes[this.my_comitentes.length - 1];
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    test() {
      console.log(this.formData.data_hora_inicial);
      console.log(new Date(this.formData.data_hora_inicial));
      console.log(new Date(this.formData.leilao_data_disponibilizar));
      console.log(new Date());

      console.log("Comparando");
      let data1 = new Date(moment(this.formData.data_hora_inicial, "DD-MM-yyyy HH:mm"));
      let data2 = new Date(moment(this.formData.leilao_data_disponibilizar, "DD-MM-yyyy HH:mm"));

      console.log(data1 >= data2);
    },

    alterarTipoLeilao() {
      if (this.formData.leilao_tipo == "extra") {
        this.formData.processo = null;
      }
    },

    changePracas() {
      if (this.formData.leilao_num_pracas < 2) {
        document.getElementById("data_leilao_2").value = "";
      }

      if (this.formData.leilao_num_pracas < 3) {
        document.getElementById("data_leilao_3").value = "";
      }

      if (this.formData.leilao_num_pracas < 4) {
        document.getElementById("data_leilao_4").value = "";
      }
    },

    async validate() {
      //this.test();

      console.log(this.formData.comitente);
      this.cadastrar_comitente = false;
      this.cadastrar_processo = false;
      this.$nextTick(async function () {
        const result = await this.v$.$validate();

        if (result) {
          this.create();
        } else {
          console.log("Não validou");
          console.log(this.v$);
          console.log(result);
        }
      });
    },

    buscarProcessoCadastrado(comitente_id) {
      let data = {
        comitente_id: comitente_id,
      };

      this.cadastrar_processo = false;

      axios
        .post(`/admin/processo/search_all`, data)
        .then((response) => {
          this.formData.processo = response.data.ultimo_processo;

          console.log("Processo cadastrado");
          console.log(response.data.ultimo_processo);

          this.buscarprocessos();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarComitenteCadastrado(comitente_id) {
      let data = {
        comitente_id: comitente_id,
      };

      this.cadastrar_comitente = false;

      axios
        .post(`/admin/comitente/search_all`, data)
        .then((response) => {
          this.buscarComitentes(true);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    //FORMATA A DATA PARA ENVIAR PARA O BANCO (De DD-MM-yyyy HH:mm:ss Para yyyy-MM-DD HH:mm:ss )
    formatSelectedDate3(date) {
      return moment(date, "DD-MM-yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    create() {
      this.isLoading = true;

      let data = {
        leilao_acionar_regressiva_apos: this.formData.leilao_acionar_regressiva_apos,
        leilao_regressiva: this.formData.leilao_regressiva,
        leilao_lote_intervalo: this.formData.leilao_lote_intervalo,
        leilao_primeiro_lote_margem_tempo: this.formData.leilao_primeiro_lote_margem_tempo,
        leiloeiro_id: this.formData.leiloeiro_id,
        leilao_taxa_administrativa: this.formData.leilao_taxa_administrativa,
        cidade_id: this.formData.cidade.id,
        estado_id: this.formData.estado.id,
        comitente_id: this.formData.comitente.id,
        leilao_modo_generico: this.formData.leilao_modo_generico,
        leilao_titulo: this.formData.leilao_titulo,
        leilao_descricao: this.formData.leilao_descricao,
        leilao_local: this.formData.leilao_local,
        logo_id: this.formData.logo.id,
        leilao_tipo: this.formData.leilao_tipo,
        leilao_num_pracas: this.formData.leilao_num_pracas,
        leilao_1_modalidade: this.formData.leilao_1_modalidade,
        leilao_1_data: this.formatDateToSave(this.formData.leilao_1_data),
        leilao_data_disponibilizar: this.formatDateToSave(this.formData.leilao_data_disponibilizar),
        leilao_tempo_limite_habilitacao: this.formData.leilao_tempo_limite_habilitacao,
        leilao_exibir_habilitados: this.formData.leilao_exibir_habilitados,
        is_teste: this.formData.is_teste,
        leilao_info_geral: this.formData.leilao_info_geral,
      };

      if (this.formData.leilao_tipo == "judicial") {
        data.processo_id = this.formData.processo.id;
      }

      if (this.formData.leilao_num_pracas < 4) {
        this.formData.leilao_4_data = null;
        this.formData.leilao_4_modalidade = null;
      } else {
        data.leilao_4_data = this.formatDateToSave(this.formData.leilao_4_data);
        data.leilao_4_modalidade = this.formData.leilao_4_modalidade;
      }

      if (this.formData.leilao_num_pracas < 3) {
        this.formData.leilao_3_data = null;
        this.formData.leilao_3_modalidade = null;
      } else {
        data.leilao_3_data = this.formatDateToSave(this.formData.leilao_3_data);
        data.leilao_3_modalidade = this.formData.leilao_3_modalidade;
      }

      if (this.formData.leilao_num_pracas < 2) {
        this.formData.leilao_2_data = null;
        this.formData.leilao_2_modalidade = null;
      } else {
        data.leilao_2_data = this.formatDateToSave(this.formData.leilao_2_data);
        data.leilao_2_modalidade = this.formData.leilao_2_modalidade;
      }

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/leilao/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Leilão cadastrado", "/admin/leilao/" + response.data.id + "/lotes/cadastrar_lote");
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    changeCidade() {
      this.cadastrar_comitente = false;
      this.cadastrar_processo = false;
      this.formData.cidade_id = this.formData.cidade.id;
      this.formData.comitente = null;
      this.buscarComitentes();
      this.buscarprocessos();
    },

    buscarCidades() {
      this.isLoading = true;

      this.cadastrar_comitente = false;
      this.cadastrar_processo = false;
      this.formData.estado_id = this.formData.estado.id;
      this.formData.cidade_id = null;
      this.formData.comitente = null;

      //this.buscarComitentes();
      this.my_comitentes = [];
      this.my_processos = [];

      //this.buscarprocessos();

      let data = {
        estado_id: this.formData.estado.id,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          this.formData.cidade = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
v-autocomplete {
  height: 40px !important;
  max-height: 40px !important;
  margin: 0px;
  padding: 0px;
}
</style>
